<template>
  <div class="flex flex-wrap col-12 justify-end items-center">
    <div class="col-8 lg-col-8 md-col-8 sm-col-7 flex flex-wrap" :class="[{ 'disabled': isMandatory || !isActive}]">
      <span class="flex col-12 h5 bold sm-hide xs-hide ml2">
        {{ capitalizeFirstLetter(localOption.name) }}</span>
      <span class="flex col-12 h6 bold lg-hide md-hide ml2">
        {{ capitalizeFirstLetter(localOption.name) }}</span>
      <div v-if="localOption.tdaDescription">
        <span class="flex col-12 h6 bold sm-hide xs-hide ml2">
          {{ capitalizeFirstLetter(localOption.tdaDescription) }}</span>
        <span class="flex col-12 h7 bold lg-hide md-hide ml2">
          {{ capitalizeFirstLetter(localOption.tdaDescription) }}</span>
      </div>
      <div class="flex col-12">
        <span v-if=" getPrice > 0" class="h6 cond lower ml2">{{ getPrice.toFixed(2) }} €<span v-if="isOptionRecurring" class="h6"> / mois</span></span>
        <span v-else class="h6 cond lower ml2">Offert</span>
      </div>
    </div>

    <div
      class="flex col-4 lg-col-4 md-col-4 sm-col-5 h6n bold items-center pl1 justify-end"
    >
      <i
        v-if="showQuantityChanger && !isMandatory && !isOptionQuantitySelectedDisabled && localOption.quantity > 0"
        :id="`option-quantity-minus-${index}`"
        style="top: 2px"
        :class="[{'icon icon-minus h2 pointer': true},{'disabled':canShow(-1)}]"
        @click="handleQuantityChange(-1)"
      ></i>
      <span class="mx1">{{ localOption.quantity }}</span>
      <i
        v-if="showQuantityChanger && !isMandatory && !isOptionQuantitySelectedDisabled && showAddMoreQuantityChanger"
        :id="`option-quantity-add-more-${index}`"
        style="top: 2px"
        :class="[{'icon icon-add-more-icon h2 pointer':true},{'disabled':canShow(1)}]"
        @click="handleQuantityChange(1)"
      ></i>
      <div class="flex ml2">
        <h4 v-if="getPrice > 0" class="h6 cond lower">{{ getOptionTotal.toFixed(2) }} €<span v-if="isOptionInsuranceDaily && isOfferStage" class="h4"> / jour</span><span v-if="isOptionRecurring" class="h4"> / mois</span></h4>
        <h4 v-else class="h6 cond lower">Offert</h4>
      </div>
    </div>
  </div>
</template>

<script>
import { optionTypes, capitalizeFirstLetter } from '@/utils/utils';

export default {
  props: {
    option: Object,
    index: Number
  },
  data () {
    return {
      optionTypes: optionTypes,
      localOption: { ...this.$props.option }
    };
  },
  computed: {
    isInternalSession () {
      return this.$store.state.siteInfo && this.$store.state.siteInfo.is_internal_session;
    },
    isOptionInsuranceDaily () {
      return this.localOption.detail.insurance && this.localOption.detail.insuranceDetail.insurance_type === 'DAILY';
    },
    isOfferStage () {
      const offer = this.$store.state.offerInfo;
      return offer && offer.detail ? offer.detail.stage || offer.detail.stage1D : false;
    },
    tariff () {
      return this.$store.state.cartItem.tariffs.find(tariff => tariff.tariffCategoryCode === this.option.price.tariffCategoryCode);
    },
    availableOptions () {
      return this.tariff.availableOptions || [];
    },
    isActive () {
      if (this.isInternalSession) {
        return this.tariff.options.some(o => o.uuid === this.localOption.uuid);
      }
      const { price } = this.localOption;
      return this.tariff.options.some(o => o.price.tariffCode === price.tariffCode && o.price.tariffCategoryCode === price.tariffCategoryCode);
    },
    showQuantityChanger () {
      return this.option.fixedQuantity ? this.option.quantity > 1 : true;
    },
    showAddMoreQuantityChanger () {
      return this.option.hasMaxQuantity ? this.localOption.quantity < this.option.maxQuantity : true;
    },
    getPrice () {
      const price = this.localOption.detail.prices.find(p => p.tariffCategoryCode === this.tariff.tariffCategoryCode);

      if (this.localOption.promo) {
        const promo = price.promotions.find(prom => prom.id === this.localOption.promo.id);

        if (promo) {
          return promo.price;
        }
      }
      return parseFloat(price.price / 100);
    },
    getOptionTotal () {
      const price = this.localOption.detail.prices.find(p => p.tariffCategoryCode === this.tariff.tariffCategoryCode);

      if (this.localOption.promo) {
        const promo = price.promotions.find(prom => prom.id === this.localOption.promo.id);

        if (promo) {
          return this.localOption.quantity * promo.price;
        }
      }
      return this.localOption.quantity * parseFloat(price.price / 100);
    },
    isMandatory () {
      return this.localOption.optionType === this.optionTypes.MANDATORY;
    },
    isOptionQuantitySelectedDisabled () {
      return this.localOption.detail.recurring;
    },
    isOptionRecurring () {
      return this.$store.state.offerInfo.detail.recurring && !this.option.registrationFees;
    }
  },
  methods: {
    capitalizeFirstLetter,
    canAdd (quantityToUpdate) {
      if (this.localOption.fixedQuantity) {
        const optionInAvailableOptions = this.availableOptions.find(option => {
          if (this.isInternalSession) {
            return option.uuid === this.localOption.uuid;
          }
          return option.horanet_product.horanet_product_code === this.localOption.horanet_product.horanet_product_code;
        });
        if (optionInAvailableOptions && optionInAvailableOptions.quantity < quantityToUpdate) {
          return false;
        }
      } else if (this.localOption.optionType === this.optionTypes.MANDATORY && quantityToUpdate === 0) {
        return false;
      }
      return true;
    },
    canShow (quantity) {
      const quantityToUpdate = parseInt(this.localOption.quantity) + (quantity);
      const canAdd = this.canAdd(quantityToUpdate);

      if (quantityToUpdate < 0) {
        return true;
      }
      return !canAdd;
    },
    handleQuantityChange (quantity) {
      const quantityToUpdate = parseInt(this.localOption.quantity) + (quantity);
      const canAdd = this.canAdd(quantityToUpdate);

      if (!canAdd) {
        return;
      }

      this.localOption.quantity = quantityToUpdate > 0 ? quantityToUpdate : 0;
      this.$emit('manageOption', { ...this.localOption });
    },
    toggleOption () {
      if (this.localOption.optionType === this.optionTypes.OPTIONAL) {
        this.$emit('manageOption', { ...this.localOption });
      }
    }
  }
};
</script>
